
import axios from "axios";

import { BacklogUrl } from "@/auth.config";

const backlog = axios.create({
	baseURL: BacklogUrl,
	headers: { Authorization: localStorage.getItem("BackLogToken") }
});

// This project got frozen due to lack of developpement time for adaptation in our FrontEnd
// The goal was a complete refactoring of the backend, now including authentication, etc

export default {
	async login(username, password) {
		const formData = new FormData();
		formData.append("username", username);
		formData.append("password", password);
		const token = await backlog.post("/auth/token", formData);
		const BackLogToken = token.data.token_type + ' ' + token.data.access_token;
		backlog.defaults.headers.common.Authorization = BackLogToken;
		localStorage.setItem("BackLogToken", BackLogToken);
		// console.log(" [>] Backlog login");
		return BackLogToken;
	},
	get_user_infos() {
		return backlog.get("/user/me");
	},



	get_all_installs() {
		return backlog.get("/install/all");
	},
	get_install_by_id(install_id) {
		return backlog.get("/install/id/" + install_id);
	},
	put_install_by_id(install_id, data) {
		return backlog.put("/install/id/" + install_id, { description: data[0], rampants: data[1], inverters: data[2], modules: data[3], history: data[4], layouts: data[5] });
	},
	delete_install_by_id(install_id) {
		return backlog.delete("/install/id/" + install_id);
	},
	post_helio_install(helio_id) {
		return backlog.post("/install/id/" + helio_id);
	},
	create_new_install() {
		return backlog.post("/install/new");
	},



	get_edges_by_id(edge_id) {
		return backlog.get("/install/edge/id/" + edge_id);
	},
	put_edges_by_id(edge_id, coordinates) {
		return backlog.put("/install/edge/id/" + edge_id, { coordinates });
	},
	delete_edges_by_id(edge_id) {
		return backlog.delete("/install/edge/id/" + edge_id);
	},
	post_new_edge(install_id, coordinates) {
		return backlog.post("/install/edge/new/" + install_id, { coordinates });
	},
	get_edges_by_install_id(install_id) {
		return backlog.get("/install/id/" + install_id + "/edges");
	},
	post_edges_by_install_id(install_id, edgelist) {
		return backlog.post("/install/id/" + install_id + "/edges", edgelist);
	},
	delete_edges_by_install_id(install_id) {
		return backlog.delete("/install/id/" + install_id + "/edges");
	},



	get_blocs_by_id(bloc_id) {
		return backlog.get("/install/bloc/id/" + bloc_id);
	},
	put_blocs_by_id(bloc_id, coordinates, measure_pts) {
		return backlog.put("/install/bloc/id/" + bloc_id, { coordinates, measure_pts });
	},
	delete_blocs_by_id(bloc_id) {
		return backlog.delete("/install/bloc/id/" + bloc_id);
	},
	post_new_bloc(install_id, coordinates, measure_pts) {
		return backlog.post("/install/bloc/new/" + install_id, { coordinates, measure_pts });
	},
	get_blocs_by_install_id(install_id) {
		return backlog.get("/install/id/" + install_id + "/blocs");
	},
	post_blocs_by_install_id(install_id, bloclist) {
		return backlog.post("/install/id/" + install_id + "/blocs", bloclist);
	},
	delete_blocs_by_install_id(install_id) {
		return backlog.delete("/install/id/" + install_id + "/blocs");
	},



	get_visudatas(install_id) {
		return backlog.get("/visudata/install/" + install_id);
	},
	post_visudatas(install_id, name, levels, values) {
		return backlog.post("/visudata/install/" + install_id, { name, levels, values });
	},
	delete_visudatas(install_id) {
		return backlog.delete("/visudata/install/" + install_id);
	},



	logout() {
		delete backlog.defaults.headers.common.Authorization;
		localStorage.removeItem("BackLogToken");
		// console.log(" [>] Backlog logout");
		return;
	}
};

// EOF
